export const SocioLabLink = (props: any) => {
  const { children, cssId } = props
  return (
    <a id={cssId} rel="noreferrer" href="http://depts.washington.edu/sociolab/" target="_blank">{children}</a>
  )
}
